<template>
  <div id="app">
      <!-- <img src="@/assets/images/bg.jpg" alt=""> -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss">
html, body, #app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
img{
  display: block;
  width: 100%;
}
</style>
<style lang="scss" scope>
  
  
</style>
